import {Rows} from "Components/Layout/Table";

const PlatformTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    brands: {
        field: 'name',
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default PlatformTable